<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Parecer Financeiro
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        :itens="parecerFinanceiro"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-parecer-financeiro
                                :pleito="pleito"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-parecer-financeiro>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-excluir-parecer-financeiro
                                :pleito="pleito"
                                class="text-danger float-left mr-1"
                                :parecer="data"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-excluir-parecer-financeiro>
                    </template>
                    <template slot="justificativa" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.justificativa }}
                        </p>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
    
<script>
import BtnInserirParecerFinanceiro from './BtnInserirParecerFinanceiro'
import BtnExcluirParecerFinanceiro from './BtnExcluirParecerFinanceiro'

export default {
    components: {
        BtnInserirParecerFinanceiro,
        BtnExcluirParecerFinanceiro
    },

    props: {
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object,
        },
        pleitoParecerFinanceiro: {
            type: Array,
        }
    },

    data() {
        return {
            erros: [],
            parecerFinanceiro: [],
            justificativa:null,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'justificativa',
                    label: 'Parecer Financeiro',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterParecerFinanceiro(this.$route.params.pleitoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.parecerFinanceiro = response.data
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
    },
    mounted() {
        this.parecerFinanceiro = this.pleitoParecerFinanceiro
    }
}
</script>
